// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.selectionLocation_Outer {
  /* border: 1px solid rgb(130, 129, 129); */
  margin: 0px 10px 0px 10px;
  height: 316px;
}
.input_selection {
  display: flex;
  margin: -18px 0px 0px 16px;
}
.input_selection p {
  font-size: 12px;
}
.input_selection input {
  width: 2%;
}
.input_selection_container {
  margin-left: 40px;
  margin-top: 5px;
}
.selectionLocation_Inner p {
  font-size: 13px;
  color: #333;
  margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/SelecrionLocation/SelectionLocation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n.selectionLocation_Outer {\n  /* border: 1px solid rgb(130, 129, 129); */\n  margin: 0px 10px 0px 10px;\n  height: 316px;\n}\n.input_selection {\n  display: flex;\n  margin: -18px 0px 0px 16px;\n}\n.input_selection p {\n  font-size: 12px;\n}\n.input_selection input {\n  width: 2%;\n}\n.input_selection_container {\n  margin-left: 40px;\n  margin-top: 5px;\n}\n.selectionLocation_Inner p {\n  font-size: 13px;\n  color: #333;\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
